// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"bd194e4d","396":"bd194e4d","412":"bd194e4d","715":"bd194e4d","737":"bd194e4d","869":"bd194e4d"}[chunkId] + ".chunk.js";
};